import React from "react"
import cn from "classnames"

import styles from "./input.module.scss"

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string
}

const Input = ({ label, className, id, ...inputProps }: InputProps) => (
  <div>
    {label && (
      <label htmlFor={id} style={{ padding: "0 10px" }}>
        {label}
      </label>
    )}
    <div className={styles.container}>
      <input id={id} className={cn(styles.input, className)} {...inputProps} />
    </div>
  </div>
)

export default Input
